export const STUDENT_ROLE = 1;
export const RECRUITER_ROLE = 2;
export const RESUME = [
  "Personal Information",
  "Education",
  "Additional Experience",
  "Relevant Project",
  "Skills",
];
export const RESUME_UNDERSCORE = [
  "Personal_Info",
  "Education",
  "Work_Experience",
  "Relevant_Projects",
];
export const SKILLS = [
  {
    name: "Agile Scrum",
    id: "180",
  },
  {
    name: "Analysis Design",
    id: "276",
  },
  {
    name: "Android",
    id: "101",
  },
  {
    name: "Articulate",
    id: "113",
  },
  {
    name: "Artificial Intelligence",
    id: "138",
  },
  {
    name: "Aws",
    id: "89",
  },
  {
    name: "Accredited Pension Representative",
    id: "17",
  },
  {
    name: "Active Listening",
    id: "61",
  },
  {
    name: "Adobe",
    id: "119",
  },
  {
    name: "Advanced Software Engineer",
    id: "273",
  },
  {
    name: "Agile",
    id: "87",
  },
  {
    name: "Angularjs",
    id: "107",
  },
  {
    name: "Antivirus",
    id: "357",
  },
  {
    name: "Asic Design Engineer",
    id: "386",
  },
  {
    name: "Associate Software Design Engineer",
    id: "345",
  },
  {
    name: "Associate Technology Support Engineer",
    id: "405",
  },
  {
    name: "Bootstrap",
    id: "123",
  },
  {
    name: "Backups",
    id: "358",
  },
  {
    name: "Banking Industry",
    id: "18",
  },
  {
    name: "Building Partnerships",
    id: "26",
  },
  {
    name: "Business & Technology Integration",
    id: "274",
  },
  {
    name: "Business Development",
    id: "25",
  },
  {
    name: "C# Software Engineer",
    id: "342",
  },
  {
    name: "C++ (Programming Language)",
    id: "68",
  },
  {
    name: "Cdh",
    id: "277",
  },
  {
    name: "Crm",
    id: "103",
  },
  {
    name: "Css",
    id: "120",
  },
  {
    name: "Cti",
    id: "205",
  },
  {
    name: "Communication",
    id: "31",
  },
  {
    name: "Communications",
    id: "14",
  },
  {
    name: "Complex Problem Solving",
    id: "66",
  },
  {
    name: "Composition Software Engineer",
    id: "56",
  },
  {
    name: "Configure",
    id: "201",
  },
  {
    name: "Consulting",
    id: "23",
  },
  {
    name: "Containerization",
    id: "129",
  },
  {
    name: "Critical Thinking",
    id: "64",
  },
  {
    name: "Customer Engineer Internship-i",
    id: "37",
  },
  {
    name: "Cyber Security",
    id: "198",
  },
  {
    name: "Data Governance",
    id: "139",
  },
  {
    name: "Data Management",
    id: "140",
  },
  {
    name: "Data Migration",
    id: "278",
  },
  {
    name: "Data Science",
    id: "141",
  },
  {
    name: "Deployment",
    id: "124",
  },
  {
    name: "Design Patterns",
    id: "91",
  },
  {
    name: "Data Structures",
    id: "71",
  },
  {
    name: "Design Automation Intern",
    id: "41",
  },
  {
    name: "Designer & Project Manager",
    id: "190",
  },
  {
    name: "Digital Design Engineer",
    id: "382",
  },
  {
    name: "Director Of Technical Project Services",
    id: "197",
  },
  {
    name: "Diversity",
    id: "30",
  },
  {
    name: "Documentation",
    id: "12",
  },
  {
    name: "Enterprise Application",
    id: "279",
  },
  {
    name: "Es Application Dev Engineer",
    id: "54",
  },
  {
    name: "Excellent Verbal And Written Communication Skills",
    id: "92",
  },
  {
    name: "Ecommerce",
    id: "88",
  },
  {
    name: "Embedded Design Engineer",
    id: "385",
  },
  {
    name: "Embedded Software Internship",
    id: "42",
  },
  {
    name: "Embedded Systems Engineer",
    id: "380",
  },
  {
    name: "Emulation Engineer",
    id: "384",
  },
  {
    name: "Encriss Software Developer Trainee - Hadoop",
    id: "57",
  },
  {
    name: "Engineering",
    id: "78",
  },
  {
    name: "Engineering Intern",
    id: "36",
  },
  {
    name: "English Language",
    id: "16",
  },
  {
    name: "Equity",
    id: "1",
  },
  {
    name: "Fpga Design Engineer",
    id: "381",
  },
  {
    name: "Front End Developer",
    id: "93",
  },
  {
    name: "Financial",
    id: "20",
  },
  {
    name: "Financial Services",
    id: "199",
  },
  {
    name: "Firmware Engineer",
    id: "383",
  },
  {
    name: "Front End (Software Engineering)",
    id: "73",
  },
  {
    name: "Git",
    id: "122",
  },
  {
    name: "Html",
    id: "108",
  },
  {
    name: "Html5",
    id: "90",
  },
  {
    name: "Hardware Design",
    id: "349",
  },
  {
    name: "Hardware Engineer",
    id: "378",
  },
  {
    name: "Hardware Engineer Intern",
    id: "40",
  },
  {
    name: "Hardware Systems Architect",
    id: "264",
  },
  {
    name: "Hardware Testing",
    id: "352",
  },
  {
    name: "Hardware Troubleshooting",
    id: "351",
  },
  {
    name: "Harward Systems Architect - Arm Architecture",
    id: "272",
  },
  {
    name: "Hypertext Markup Language",
    id: "179",
  },
  {
    name: "Incident Response",
    id: "206",
  },
  {
    name: "Ionic",
    id: "121",
  },
  {
    name: "It Helpdesk Support Engineer",
    id: "408",
  },
  {
    name: "It Support Engineer",
    id: "403",
  },
  {
    name: "It Support Technician",
    id: "404",
  },
  {
    name: "Information Technology",
    id: "27",
  },
  {
    name: "Information Technology Support Engineer",
    id: "407",
  },
  {
    name: "Information Technology Support Engineer Technical Support",
    id: "412",
  },
  {
    name: "Infrastructure",
    id: "72",
  },
  {
    name: "Investment Banking",
    id: "19",
  },
  {
    name: "Irrt Software Panel Engineer",
    id: "52",
  },
  {
    name: "Java",
    id: "280",
  },
  {
    name: "Javascript",
    id: "111",
  },
  {
    name: "Jenkins",
    id: "94",
  },
  {
    name: "Java (Programming Language)",
    id: "70",
  },
  {
    name: "Javascript Developer - Procat",
    id: "51",
  },
  {
    name: "Jira Tools Developer",
    id: "55",
  },
  {
    name: "Judgment And Decision Making",
    id: "67",
  },
  {
    name: "L1 Support Engineer",
    id: "411",
  },
  {
    name: "Large-scale",
    id: "281",
  },
  {
    name: "Leadership",
    id: "212",
  },
  {
    name: "Land Development - Project Manager",
    id: "193",
  },
  {
    name: "Lead Software Developer",
    id: "176",
  },
  {
    name: "Lead Software Engineer",
    id: "170",
  },
  {
    name: "Legal",
    id: "11",
  },
  {
    name: "Linux",
    id: "128",
  },
  {
    name: "Machine Learning",
    id: "142",
  },
  {
    name: "Management",
    id: "213",
  },
  {
    name: "Ms Sql Server",
    id: "114",
  },
  {
    name: "Mathematics",
    id: "63",
  },
  {
    name: "Mechanical Engineer Internship",
    id: "35",
  },
  {
    name: "Networking",
    id: "204",
  },
  {
    name: "Nosql",
    id: "127",
  },
  {
    name: "Node.js",
    id: "106",
  },
  {
    name: "Nodejs",
    id: "83",
  },
  {
    name: "Operations",
    id: "133",
  },
  {
    name: "Operations Manager",
    id: "134",
  },
  {
    name: "Operating Systems",
    id: "202",
  },
  {
    name: "Oral Communications Skills",
    id: "4",
  },
  {
    name: "Orvito Software Engineer",
    id: "347",
  },
  {
    name: "Pega",
    id: "282",
  },
  {
    name: "Project Management",
    id: "275",
  },
  {
    name: "People Management",
    id: "86",
  },
  {
    name: "Portfolio Management",
    id: "24",
  },
  {
    name: "Principal Development Engineer",
    id: "267",
  },
  {
    name: "Process Improvements",
    id: "7",
  },
  {
    name: "Product",
    id: "185",
  },
  {
    name: "Product Marketing",
    id: "9",
  },
  {
    name: "Programming Languages",
    id: "82",
  },
  {
    name: "Project & Implementation Manager",
    id: "191",
  },
  {
    name: "Project Manager",
    id: "188",
  },
  {
    name: "Project Manager Lead",
    id: "189",
  },
  {
    name: "Project Team",
    id: "194",
  },
  {
    name: "Publishing",
    id: "10",
  },
  {
    name: "Python",
    id: "118",
  },
  {
    name: "Qe Architect",
    id: "266",
  },
  {
    name: "Quality",
    id: "21",
  },
  {
    name: "Rest",
    id: "28",
  },
  {
    name: "Restful Web Services",
    id: "125",
  },
  {
    name: "Restful Api",
    id: "84",
  },
  {
    name: "Rf Engineer Internship",
    id: "34",
  },
  {
    name: "Rtl Design Engineer",
    id: "387",
  },
  {
    name: "React.js",
    id: "105",
  },
  {
    name: "Reading Comprehension",
    id: "60",
  },
  {
    name: "Remote Platform Architect",
    id: "268",
  },
  {
    name: "Research",
    id: "177",
  },
  {
    name: "Salesforce",
    id: "102",
  },
  {
    name: "Sass",
    id: "112",
  },
  {
    name: "Sdlc",
    id: "283",
  },
  {
    name: "Siem",
    id: "207",
  },
  {
    name: "Soap",
    id: "110",
  },
  {
    name: "Soc",
    id: "208",
  },
  {
    name: "Sop",
    id: "209",
  },
  {
    name: "Sql",
    id: "109",
  },
  {
    name: "Stakeholder Engagement",
    id: "137",
  },
  {
    name: "Strong Work Ethic",
    id: "74",
  },
  {
    name: "Structured Software",
    id: "115",
  },
  {
    name: "Sales",
    id: "5",
  },
  {
    name: "Security",
    id: "200",
  },
  {
    name: "Security Analyst",
    id: "203",
  },
  {
    name: "Senior Developer & Software Engineer",
    id: "174",
  },
  {
    name: "Senior Development Project Manager",
    id: "195",
  },
  {
    name: "Senior Fpga Design Engineer",
    id: "379",
  },
  {
    name: "Senior Lead Software Engineer",
    id: "171",
  },
  {
    name: "Senior Project & Program Manager",
    id: "192",
  },
  {
    name: "Senior Project Manager - Project Management Office",
    id: "196",
  },
  {
    name: "Senior Software Design Engineer",
    id: "344",
  },
  {
    name: "Senior Software Design Engineer & Architect",
    id: "346",
  },
  {
    name: "Senior Software Developer",
    id: "167",
  },
  {
    name: "Senior Software Developer Engineer",
    id: "168",
  },
  {
    name: "Senior Software Engineer",
    id: "169",
  },
  {
    name: "Senior Software Engineer & Software Engineer",
    id: "343",
  },
  {
    name: "Senior Software Engineer & Ui Developer",
    id: "175",
  },
  {
    name: "Senior Software Engineer - Java Developer",
    id: "172",
  },
  {
    name: "Senior Software Engineer Iii",
    id: "173",
  },
  {
    name: "Senior System Development Engineer",
    id: "269",
  },
  {
    name: "Senior Technology Support Engineer",
    id: "409",
  },
  {
    name: "Server",
    id: "355",
  },
  {
    name: "Service & Offering Development",
    id: "186",
  },
  {
    name: "Services",
    id: "3",
  },
  {
    name: "Social Perceptiveness",
    id: "65",
  },
  {
    name: "Software",
    id: "81",
  },
  {
    name: "Software Developer Engineer Intern",
    id: "43",
  },
  {
    name: "Software Development Engineer Intern",
    id: "38",
  },
  {
    name: "Software Engineering",
    id: "69",
  },
  {
    name: "Software Eng",
    id: "187",
  },
  {
    name: "Software Internship",
    id: "39",
  },
  {
    name: "Sofware-as-a-service",
    id: "178",
  },
  {
    name: "Speaking",
    id: "62",
  },
  {
    name: "Support",
    id: "6",
  },
  {
    name: "System Architect",
    id: "265",
  },
  {
    name: "Systems Architect",
    id: "270",
  },
  {
    name: "Teaching",
    id: "135",
  },
  {
    name: "Team Management",
    id: "214",
  },
  {
    name: "Team Player",
    id: "136",
  },
  {
    name: "Technical Design",
    id: "284",
  },
  {
    name: "Test Case",
    id: "285",
  },
  {
    name: "Translating",
    id: "95",
  },
  {
    name: "Typescript",
    id: "117",
  },
  {
    name: "Technical Designer Architect",
    id: "271",
  },
  {
    name: "Technical Lead",
    id: "76",
  },
  {
    name: "Technical Support",
    id: "80",
  },
  {
    name: "Technical Support Analyst",
    id: "410",
  },
  {
    name: "Test",
    id: "29",
  },
  {
    name: "Tier- Support Engineer",
    id: "406",
  },
  {
    name: "Tools & Ide Software Developer",
    id: "53",
  },
  {
    name: "Training",
    id: "22",
  },
  {
    name: "Troubleshooting",
    id: "354",
  },
  {
    name: "Ui & Ux Developer & Master Trainer",
    id: "58",
  },
  {
    name: "Unavailable",
    id: "59",
  },
  {
    name: "Unit Tests",
    id: "126",
  },
  {
    name: "Use Cases",
    id: "210",
  },
  {
    name: "User Experience Design",
    id: "96",
  },
  {
    name: "User Interface",
    id: "97",
  },
  {
    name: "Ux",
    id: "100",
  },
  {
    name: "Unit Testing",
    id: "85",
  },
  {
    name: "Version Control",
    id: "98",
  },
  {
    name: "Video",
    id: "77",
  },
  {
    name: "Web Services",
    id: "116",
  },
  {
    name: "Wireframe",
    id: "99",
  },
  {
    name: "Written And Verbal",
    id: "211",
  },
  {
    name: "Web",
    id: "2",
  },
  {
    name: "Windows Server",
    id: "356",
  },
  {
    name: "Ability To Adapt",
    id: "235",
  },
  {
    name: "Ability To Learn Quickly",
    id: "394",
  },
  {
    name: "Ai Applications",
    id: "294",
  },
  {
    name: "Algorithms",
    id: "332",
  },
  {
    name: "Analytic",
    id: "306",
  },
  {
    name: "Analytical Skills",
    id: "402",
  },
  {
    name: "Analytics",
    id: "166",
  },
  {
    name: "Apis",
    id: "154",
  },
  {
    name: "Application",
    id: "45",
  },
  {
    name: "Applications",
    id: "152",
  },
  {
    name: "Assembly",
    id: "361",
  },
  {
    name: "Assessing",
    id: "216",
  },
  {
    name: "Atlassian",
    id: "398",
  },
  {
    name: "Augmented Reality",
    id: "44",
  },
  {
    name: "Automation Tools",
    id: "301",
  },
  {
    name: "Azure",
    id: "397",
  },
  {
    name: "Back-end",
    id: "157",
  },
  {
    name: "Big Data",
    id: "331",
  },
  {
    name: "Bill Of Materials",
    id: "363",
  },
  {
    name: "Build Trust",
    id: "261",
  },
  {
    name: "Building",
    id: "315",
  },
  {
    name: "Change Management",
    id: "130",
  },
  {
    name: "Cloud Technology",
    id: "388",
  },
  {
    name: "Code Compliance",
    id: "225",
  },
  {
    name: "Collaborating",
    id: "317",
  },
  {
    name: "Collaboration",
    id: "131",
  },
  {
    name: "Combined Cycle",
    id: "254",
  },
  {
    name: "Command Line",
    id: "289",
  },
  {
    name: "Commercial Processes",
    id: "244",
  },
  {
    name: "Communication Skills",
    id: "144",
  },
  {
    name: "Complex Solutions",
    id: "250",
  },
  {
    name: "Computational",
    id: "295",
  },
  {
    name: "Computer Science",
    id: "47",
  },
  {
    name: "Conceptual Thinking",
    id: "257",
  },
  {
    name: "Consensus Building",
    id: "223",
  },
  {
    name: "Control Technologies",
    id: "230",
  },
  {
    name: "Cross-functional",
    id: "240",
  },
  {
    name: "Customer Focus",
    id: "243",
  },
  {
    name: "Data Analytics",
    id: "340",
  },
  {
    name: "Debug",
    id: "146",
  },
  {
    name: "Delivering Results",
    id: "224",
  },
  {
    name: "Design",
    id: "372",
  },
  {
    name: "Design Thinking",
    id: "184",
  },
  {
    name: "Designs",
    id: "370",
  },
  {
    name: "Developing Complex",
    id: "215",
  },
  {
    name: "Development Tools",
    id: "339",
  },
  {
    name: "Devops",
    id: "338",
  },
  {
    name: "Dhcp",
    id: "391",
  },
  {
    name: "Django",
    id: "158",
  },
  {
    name: "Dns",
    id: "399",
  },
  {
    name: "Docker",
    id: "320",
  },
  {
    name: "Electrical",
    id: "247",
  },
  {
    name: "Electrical Engineering",
    id: "229",
  },
  {
    name: "Electrification",
    id: "227",
  },
  {
    name: "Energy Storage",
    id: "258",
  },
  {
    name: "Energy Storage Systems",
    id: "234",
  },
  {
    name: "Engineer",
    id: "368",
  },
  {
    name: "Engineering Analysis",
    id: "369",
  },
  {
    name: "Excellent Organizational Skills",
    id: "241",
  },
  {
    name: "Fault Finding",
    id: "359",
  },
  {
    name: "Flask",
    id: "162",
  },
  {
    name: "Flexibility",
    id: "303",
  },
  {
    name: "Flexible",
    id: "373",
  },
  {
    name: "Full Stack Development",
    id: "291",
  },
  {
    name: "Full-stack Web Development",
    id: "153",
  },
  {
    name: "Gcp",
    id: "321",
  },
  {
    name: "Great Communication Skills",
    id: "392",
  },
  {
    name: "Hadoop",
    id: "324",
  },
  {
    name: "Hardware",
    id: "348",
  },
  {
    name: "Hardware Design Engineer",
    id: "350",
  },
  {
    name: "Human Centred Design",
    id: "183",
  },
  {
    name: "Impact",
    id: "33",
  },
  {
    name: "Innovative",
    id: "316",
  },
  {
    name: "Integrated Systems",
    id: "242",
  },
  {
    name: "Intellectually Curious",
    id: "333",
  },
  {
    name: "Interpersonal",
    id: "165",
  },
  {
    name: "It Infrastructure",
    id: "328",
  },
  {
    name: "Jamf",
    id: "393",
  },
  {
    name: "Kubernetes",
    id: "304",
  },
  {
    name: "Leaders",
    id: "255",
  },
  {
    name: "Lean",
    id: "302",
  },
  {
    name: "Marketing",
    id: "219",
  },
  {
    name: "Mathematical Programming",
    id: "325",
  },
  {
    name: "Mechanical Engineering",
    id: "375",
  },
  {
    name: "Meet Goals",
    id: "251",
  },
  {
    name: "Meet Tight Deadlines",
    id: "220",
  },
  {
    name: "Mongodb",
    id: "335",
  },
  {
    name: "Motivated",
    id: "150",
  },
  {
    name: "National Security",
    id: "32",
  },
  {
    name: "Negotiation",
    id: "253",
  },
  {
    name: "Network",
    id: "395",
  },
  {
    name: "Network Administration",
    id: "390",
  },
  {
    name: "Network Design",
    id: "362",
  },
  {
    name: "Object-oriented Programming",
    id: "293",
  },
  {
    name: "Organisations",
    id: "326",
  },
  {
    name: "Organizing",
    id: "367",
  },
  {
    name: "Ownership",
    id: "237",
  },
  {
    name: "Pandas",
    id: "310",
  },
  {
    name: "Platforms",
    id: "396",
  },
  {
    name: "Postgres",
    id: "337",
  },
  {
    name: "Power Plants",
    id: "228",
  },
  {
    name: "Proactive",
    id: "160",
  },
  {
    name: "Problem Solving",
    id: "314",
  },
  {
    name: "Problem-solver",
    id: "305",
  },
  {
    name: "Problem-solving",
    id: "239",
  },
  {
    name: "Problem-solving Skills",
    id: "238",
  },
  {
    name: "Production Systems",
    id: "401",
  },
  {
    name: "Program Delivery",
    id: "376",
  },
  {
    name: "Programming",
    id: "50",
  },
  {
    name: "Programming Skills",
    id: "46",
  },
  {
    name: "Project Delivery",
    id: "132",
  },
  {
    name: "Proposals",
    id: "263",
  },
  {
    name: "Prototyping",
    id: "365",
  },
  {
    name: "Quote",
    id: "217",
  },
  {
    name: "Reasoning",
    id: "336",
  },
  {
    name: "Redis",
    id: "299",
  },
  {
    name: "Reliable",
    id: "245",
  },
  {
    name: "Requirements Analysis",
    id: "374",
  },
  {
    name: "Resilient",
    id: "233",
  },
  {
    name: "Rest Apis",
    id: "149",
  },
  {
    name: "Result-oriented",
    id: "246",
  },
  {
    name: "Saas",
    id: "389",
  },
  {
    name: "Sales Force",
    id: "252",
  },
  {
    name: "Scipy",
    id: "341",
  },
  {
    name: "Segments",
    id: "221",
  },
  {
    name: "Service",
    id: "308",
  },
  {
    name: "Software Design",
    id: "311",
  },
  {
    name: "Software Development",
    id: "307",
  },
  {
    name: "Software Development Life Cycle",
    id: "290",
  },
  {
    name: "Software Development Lifecycle",
    id: "151",
  },
  {
    name: "Software Development Practices",
    id: "286",
  },
  {
    name: "Software Solutions",
    id: "313",
  },
  {
    name: "Spark",
    id: "318",
  },
  {
    name: "Stakeholders",
    id: "163",
  },
  {
    name: "Strong Communication Skills",
    id: "297",
  },
  {
    name: "Systems Engineering",
    id: "371",
  },
  {
    name: "Tech Savvy",
    id: "148",
  },
  {
    name: "Technical Development",
    id: "260",
  },
  {
    name: "Technical Leadership",
    id: "236",
  },
  {
    name: "Technical Proposal",
    id: "226",
  },
  {
    name: "Technical Sales",
    id: "259",
  },
  {
    name: "Technical Solutions",
    id: "218",
  },
  {
    name: "Technical Teams",
    id: "322",
  },
  {
    name: "Test-driven Development",
    id: "309",
  },
  {
    name: "Turbines",
    id: "222",
  },
  {
    name: "Ui",
    id: "156",
  },
  {
    name: "Unix",
    id: "296",
  },
  {
    name: "Unix Operating System",
    id: "364",
  },
  {
    name: "User Experience",
    id: "181",
  },
  {
    name: "Verbal",
    id: "256",
  },
  {
    name: "Vuejs",
    id: "155",
  },
  {
    name: "Web Applications",
    id: "48",
  },
  {
    name: "Web Development",
    id: "147",
  },
  {
    name: "Web Technologies",
    id: "300",
  },
  {
    name: "Willingness",
    id: "249",
  },
  {
    name: "Willingness To Travel",
    id: "232",
  },
  {
    name: "Work-life Balance",
    id: "377",
  },
  {
    name: "Writing",
    id: "360",
  },
];
export const RESUME_DATA = {
  Personal_Info: {
    first_name: "",
    last_name: "",
    Email: "",
    Phone: "",
    City: "",
    Personal_Website: "",
    LinkedIn: "",
  },
  Education: {
    School: "",
    Degree: "",
    Location: "",
    Major: "",
    Start: new Date(),
    End: new Date(),
    Present: false,
    Description: "",
  },
  Relevant_Projects: {
    Project_Name: "",
    Description: "",
  },
  Work_Experience: {
    Company: "",
    Position: "",
    Location: "",
    Start: new Date(),
    End: new Date(),
    Present: false,
    Description: "",
  },
};
